var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFavourite40 = function SvgFavourite40(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 38c9.941 0 18-8.059 18-18S29.941 2 20 2 2 10.059 2 20s8.059 18 18 18Zm-5.16-10.287 4.974-2.615a.4.4 0 0 1 .372 0l4.974 2.615a.4.4 0 0 0 .58-.422l-.95-5.539a.4.4 0 0 1 .116-.354l4.024-3.922a.4.4 0 0 0-.221-.683l-5.562-.808a.4.4 0 0 1-.301-.219l-2.487-5.04a.4.4 0 0 0-.718 0l-2.487 5.04a.4.4 0 0 1-.301.22l-5.562.807a.4.4 0 0 0-.221.683l4.024 3.922a.4.4 0 0 1 .115.354l-.95 5.54a.4.4 0 0 0 .58.421Z",
    fill: "#666"
  })));
};
export default SvgFavourite40;